export const defaultId = '00000000-0000-0000-0000-000000000000';
export const useIntegral = 'useIntegral';
export const integral2money = 'integral2money';
export const INVITE_ID = 'inviteId';
export const LOADING = 'loading';
export const NOMORE = 'noMore';